import { faBars, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React,{useState} from 'react'
import styled from 'styled-components'
import theme from '../../themes';


const ToggleButtonContainer = styled.div`
position:absolute;
right:20px;
color:${theme.primary};
margin-top:5px;
display:none;

@media screen and (max-width:580px){
    display:block;
}
`;

const ToggleButtonIcon = styled.a`
width:100%;
height:100%;
margin-top:10px;

:hover{
    color:${theme.secondary};
}



`



export function ToggleButton (props){
return(
    <ToggleButtonContainer>

        <ToggleButtonIcon {...props}>{props.children}</ToggleButtonIcon>
    </ToggleButtonContainer>
)
}